export default __webpack_public_path__ + "static/media/chat-admin.bbd5a7ae.svg";